import { animate, style, transition, trigger } from '@angular/animations';
import { AsyncPipe } from '@angular/common';
import { AfterViewInit, Component, ElementRef, inject, NgModule, ViewChild } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AccessbilityLinkComponent } from '@common/accessibility/frontend-shared';
import { FeedbackButtonComponent } from '@common/feedback/frontend';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { UiIconComponent } from '@common/ui/frontend-shared/icons';
import { AccessState } from '@core/frontend-shared';
import { FeatureMenuItemService, ReplaceableComponent, RouterLinkResolverPipe } from '@core/frontend-shared/feature';
import { Store } from '@ngxs/store';
import { LayoutFrontpageComponent } from '@pflegetheke/ui/frontend-shared/layout-frontpage';
import { Observable } from 'rxjs';

@ReplaceableComponent()
@Component({
    selector: 'pflegetheke-landingpage',
    templateUrl: './landingpage.component.html',
    styleUrls: ['./landingpage.component.scss'],
    animations: [
        trigger('OutAnimation', [
            transition(':leave', [
                style({ opacity: 1 }),
                animate('.9s ease-in', style({ opacity: 0 }))
            ])
        ]),
    ],
    styles: [],
    imports: [LayoutFrontpageComponent, FeedbackButtonComponent, UiButtonComponent, RouterLink, UiIconComponent, AsyncPipe, RouterLinkResolverPipe, AccessbilityLinkComponent]
})
export class LandingpageComponent implements AfterViewInit {

	loggedIn$ = inject(Store).select(AccessState.loggedIn) 
	userData$ = inject(Store).select(AccessState.accessData('user')) 
	isManager$ = inject(Store).select(AccessState.accessData('isManager')) 

	hasManagerMenuItems$:Observable<boolean>;
	
	@ViewChild('video',{static:false}) video:ElementRef;
	muteState = true;
	videoVisible = true;

	constructor(
		featureMenuItemService:FeatureMenuItemService,
	) {
		this.hasManagerMenuItems$ = featureMenuItemService.hasAccessibleMenuItems('managementToolbar')
	}


	ngAfterViewInit() {
		this.video.nativeElement.addEventListener('timeupdate', this.videoListener);
	}

	videoListener = (event) => {
		const progress = this.video.nativeElement.currentTime / this.video.nativeElement.duration;
		if(progress>.95) {
			this.video.nativeElement.removeEventListener('timeupdate', this.videoListener);
			this.videoVisible = false;
		}
	}

	// toggleVideoMuteState() {
	// 	const video = this.video.nativeElement;
	// 	this.muteState = video.muted = !video.muted;
	// }

}
